export interface ManualPlanningFormProfile {
  manualPosition: string
}

export const defaultValues: ManualPlanningFormProfile = {
  manualPosition: '',
}
